import React from "react";
import "./src/locales/i18n";
// import { ToastProvider } from "./src/components/ToastContext";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./src/components/theme";
import { GlobalStyle } from "./src/components/common/GlobalStyle";
// import { I18nextProvider } from "react-i18next";
// import i18n from "./src/locales/i18n";
import Notifications from 'react-notify-toast';
import SWUpdateNotifier from './src/components/SWUpdateNotifier';
import { UserProvider } from './src/components/context/UserContext';

export const wrapRootElement = ({ element }) => (
    <ThemeProvider theme={lightTheme}>
      {/* <ToastProvider> */}
      <UserProvider>
        <GlobalStyle />
        {element}
        <Notifications />
        <SWUpdateNotifier />
        </UserProvider>
    </ThemeProvider>
 
);

// 👉 Gatsby-Event: löst bei echtem SW-Update aus
export const onServiceWorkerUpdateReady = () => {
  // Custom DOM-Event feuern (global)
  window.dispatchEvent(new Event("swUpdateAvailable"));
};